import { DatabaseConnectionNodeData } from "src/constants/NodeDataTypes";
import { OutputMappingBE } from "src/integrationNode/types";

const extractResponseToggle = (responseField: OutputMappingBE) => ({
  id: responseField.id,
  value: `data.${responseField.mapped_to}`,
});

export const extractDatabaseConnectionFields = (
  data: DatabaseConnectionNodeData,
) => {
  return [
    ...data.variables.flatMap((variable) => [
      {
        id: variable.id_key,
        value: variable.key,
      },
      {
        id: variable.id_expression,
        value: variable.expression,
      },
    ]),
    {
      id: data.query.id,
      value: data.query.expression,
    },
    ...Object.values(data.response)
      .filter((response) => response?.active)
      .map((activeResponse) => extractResponseToggle(activeResponse)),
  ];
};
